import React from 'react';
import PropTypes from 'prop-types';
import filesize from 'filesize';

import constants from '../../../../qti/Constants';
import objectTypes from '../../../../constants/ObjectTypes';
import dateTimeService from '../../../../services/DateTimeService';
import stringUtils from '../../../../qti/utils/StringUtils';

import RemoveFileModal from './RemoveFileModal';
import DownloadButton from './../../../../components/buttons/DownloadButton';
import RemoveButton from './RemoveButton';
import UploadButton from './UploadButton';

import styles from './uploadInteraction.scss';
import a11yIIBScreenReaderService from '../../../../services/a11yIIBScreenReaderService';

const examContext = constants.componentContexts.EXAM;

class UploadViewFileUploaded extends React.Component {
    static propTypes = {
        context: PropTypes.string.isRequired,
        fileInfo: PropTypes.object.isRequired,
        handleFileSelection: PropTypes.func.isRequired,
        isCurrent: PropTypes.bool,
        isReadOnly: PropTypes.bool,
        model: PropTypes.object.isRequired,
        questionModel: PropTypes.object.isRequired,
        previousView: PropTypes.string,
        removeUploadedFile: PropTypes.func.isRequired,
        services: PropTypes.object.isRequired,
        uploadCompletedAt: PropTypes.object.isRequired,
        userResponse: PropTypes.array,
    };

    state = { showRemoveFileModal: false };

    componentDidMount() {
        const { isCurrent, previousView, questionModel } = this.props;
        if (isCurrent && previousView !== undefined && questionModel.objectType === objectTypes.UPLOAD) {
            this.initiallyFocusedElement.focus();
        }
    }

    componentDidUpdate(prevProps) {
        const { isCurrent, userResponse } = this.props;
        if (isCurrent && userResponse?.[0] !== prevProps.userResponse?.[0]) {
            this.initiallyFocusedElement.focus();
        }
    }

    openRemoveFileModal = () => {
        this.setState({ showRemoveFileModal: true });
    };

    closeRemoveFileModal = () => {
        this.setState({ showRemoveFileModal: false });
    };

    render() {
        const { context, fileInfo = {}, isReadOnly, services } = this.props;
        const { t } = services.translationService;
        const { supportedFileExtensions } = this.props.model;
        const id = stringUtils.getUID();
        let fileSize = '-';
        let formattedUploadCompletedAt = '-';
        const tabIndexValue = a11yIIBScreenReaderService.getTabIndexValue(undefined);

        try {
            if (fileInfo.fileSize) {
                fileSize = filesize(fileInfo.fileSize);
            }
        } catch (error) {
            window.console.error(error);
        }
        try {
            formattedUploadCompletedAt = dateTimeService.formatDateTime(this.props.uploadCompletedAt);
        } catch (error) {
            window.console.error(error);
        }

        return (
            <div className={styles.fileUploadedView}>
                <RemoveFileModal
                    closeConfirmation={this.closeRemoveFileModal}
                    isOpen={this.state.showRemoveFileModal}
                    removalHandler={this.props.removeUploadedFile}
                    services={this.props.services}
                />

                <div
                    className={styles.fileUploadedText}
                    tabIndex="-1"
                    ref={(div) => { this.initiallyFocusedElement = div; }}
                >
                    {t('interactions.upload.fileUploadedText')}
                </div>

                <div className={styles.fileUploadedButtonRow}>
                    <DownloadButton
                        {...this.props}
                        usePresignUrl
                    />
                    <RemoveButton
                        disabled={isReadOnly}
                        removalHandler={this.props.removeUploadedFile}
                        showConfirmation={this.openRemoveFileModal}
                        services={services}
                    />
                    <UploadButton
                        handleFileSelection={this.props.handleFileSelection}
                        disabled={isReadOnly || context !== examContext}
                        id={id}
                        supportedFileExtensions={supportedFileExtensions}
                        text={t('interactions.upload.btnReplace')}
                    />
                </div>
                {fileInfo.fileSize ?
                    <table className={styles.fileInfoTable} tabIndex={tabIndexValue}>
                        <tbody>
                            <tr>
                                <th>{t('interactions.upload.columnLabelFileName')}</th>
                                <td>
                                    <span className={styles.fileName}>{fileInfo.fileName ? fileInfo.fileName : '-'}</span>
                                </td>
                            </tr>
                            <tr>
                                <th>{t('interactions.upload.columnLabelFileType')}</th>
                                <td>{fileInfo.fileType ? fileInfo.fileType : '-'}</td>
                            </tr>
                            <tr>
                                <th>{t('interactions.upload.columnLabelFileSize')}</th>
                                <td>{fileSize}</td>
                            </tr>
                            <tr>
                                <th>{t('interactions.upload.columnLabelTimeUploaded')}</th>
                                <td>{formattedUploadCompletedAt}</td>
                            </tr>
                            <tr>
                                <th>{t('interactions.upload.columnLabelStatus')}</th>
                                <td>{t('interactions.upload.statusSaved')}</td>
                            </tr>
                        </tbody>
                    </table>
                    : null }
            </div>
        );
    }
}

export default UploadViewFileUploaded;
